/**
 * Select2 UI strings aligned with the active application locale.
 * Used by backend popups, autocomplete fields, and other searchable dropdowns.
 */
export function getUiLang() {
    var windowLocale = (typeof window.locale === 'string' && window.locale)
        ? window.locale.split('_')[0]
        : '';
    var storedLocale = (window.localStorage && localStorage.getItem('locale'))
        ? localStorage.getItem('locale')
        : '';
    var storedLang = storedLocale ? storedLocale.split('_')[0] : '';
    var i18nLang = (window.i18next && i18next.language) ? i18next.language : '';
    var htmlLang = document.documentElement.getAttribute('lang') || '';

    // Backend session locale wins over stale frontend localStorage.
    var lang = (windowLocale || storedLang || i18nLang || htmlLang || 'en').toLowerCase();
    return lang.indexOf('de') === 0 ? 'de' : 'en';
}

export function buildSelect2Language() {
    var lang = getUiLang();
    var t = function (en, de) {
        return lang === 'de' ? de : en;
    };

    return {
        errorLoading: function () {
            return t('The results could not be loaded.', 'Die Ergebnisse konnten nicht geladen werden.');
        },
        inputTooLong: function (args) {
            var over = args && args.input ? (args.input.length - args.maximum) : 0;
            return t('Please delete ' + over + ' character(s).', 'Bitte löschen Sie ' + over + ' Zeichen.');
        },
        inputTooShort: function (args) {
            var remaining = args && args.minimum ? (args.minimum - (args.input ? args.input.length : 0)) : 0;
            return t('Please enter ' + remaining + ' or more character(s).', 'Bitte geben Sie mindestens ' + remaining + ' weitere Zeichen ein.');
        },
        loadingMore: function () {
            return t('Loading more results…', 'Lade weitere Ergebnisse…');
        },
        maximumSelected: function (args) {
            var max = args && args.maximum ? args.maximum : 0;
            return t('You can only select ' + max + ' item(s).', 'Sie können nur ' + max + ' Einträge auswählen.');
        },
        noResults: function () {
            return t('No matches found', 'Keine Übereinstimmungen gefunden');
        },
        searching: function () {
            return t('Searching…', 'Suche…');
        },
    };
}

export function applySelect2Defaults() {
    if (typeof $ !== 'undefined' && $.fn && $.fn.select2 && $.fn.select2.defaults) {
        $.fn.select2.defaults.set('language', buildSelect2Language());
    }
}

// Allow non-module scripts (loadmodules) to reuse the same language pack.
if (typeof window !== 'undefined') {
    window.getSelect2UiLang = getUiLang;
    window.buildSelect2Language = buildSelect2Language;
    window.applySelect2Defaults = applySelect2Defaults;
}
